import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

function Footer() {
  return (
    <AppBar position="fixed" sx={{ top: 'auto', bottom: 0 }}>
      <Toolbar>
        <Box sx={{ flexGrow: 1 }}>
          <Typography variant="body1" align="center">
            (C) Alpha Grand Rapids, Grand Rapids, MI, 2024 V2.9
          </Typography>
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default Footer;
